import { Stack } from '@mui/material';
import { ROUTES } from 'config';
import {
  ShopInternalItemDetails,
  ShopInternalDisabledFeatureAlert,
} from 'containers/shop';
import {
  Loader,
  NothingFoundAlert,
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { useInternalShopItem } from 'store/internal-shop';
import { useRouteParams } from 'utils/useIdParam';

const ShopInternalItemDetailsPage: FC = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const { id: itemId } = useRouteParams(ROUTES.shop.internal.items.details);

  const { data: item, isLoading } = useInternalShopItem(itemId);

  if (itemId && isLoading) return <Loader />;
  if (itemId && !item) return <NothingFoundAlert />;

  return (
    <Stack gap={2}>
      <ShopInternalDisabledFeatureAlert />

      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('shop.internal.title'),
            url: ROUTES.shop.internal.items.list,
          },
          {
            label: !itemId
              ? t('marketplaceItems.addMarketplaceItem')
              : item
              ? item.name
              : '',
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'settings',
                label: t('common.settings'),
                url: itemId
                  ? ROUTES.shop.internal.items.details.replace(':id', itemId)
                  : ROUTES.shop.internal.items.create,
                isActive:
                  path === ROUTES.shop.internal.items.details ||
                  path === ROUTES.shop.internal.items.create,
                disabled: !item,
              },
            ]}
          />
        }
      >
        <ShopInternalItemDetails />
      </PageContentLayout>
    </Stack>
  );
};

export default ShopInternalItemDetailsPage;
